export default __webpack_public_path__ + "static/media/Asset_46.806d22d9.png";